import { Marker, Popup } from "react-leaflet";
import { Box, Typography } from "@mui/material";
import {
  formatHeatmapTimestamp,
  formatHeatmapValue,
  HEATMAP_MEASURES,
} from "../../utils/sensorHeatmapUtils";

const SensorHeatmapMarkers = ({ data, sensors = [] }) => {
  const measure = HEATMAP_MEASURES.find(
    (item) => item.apiKey === data.measurement_name,
  );
  return data.sensors.map((reading) => {
    const sensor = sensors.find(
      (item) => String(item.id) === String(reading.sensor_id),
    );
    return (
      <Marker
        key={reading.sensor_id}
        position={[reading.latitude, reading.longitude]}
      >
        <Popup>
          <Box display="flex" flexDirection="column" gap={0.5}>
            <Typography fontWeight="bold" fontSize="14px">
              {sensor?.nickname || reading.sensor_id}
            </Typography>
            <Typography fontSize="12px">
              Media oraria · {measure?.label}
            </Typography>
            <Typography fontSize="14px">
              {formatHeatmapValue(reading.value)}
              {reading.value !== null && measure?.unit
                ? ` ${measure.unit}`
                : ""}
            </Typography>
            <Typography fontSize="12px" color="text.secondary">
              {formatHeatmapTimestamp(data.start_timestamp)}
            </Typography>
          </Box>
        </Popup>
      </Marker>
    );
  });
};

export default SensorHeatmapMarkers;
